module.exports = __webpack_public_path__ + "static/media/01.b4490f4d.jpg";